module.exports = __webpack_public_path__ + "static/media/hint.821ebc8a.svg";